<div #appGenericPieChart class="bar-chart-container ion-text-center" style="min-height: 225px; margin-bottom: 8px;">
  <canvas baseChart chartType="pie" [data]="chartData" [labels]="chartLabel" [colors]="chartColor" [legend]="isShowLegend" [options]="chartOptions" > </canvas>
</div>
